import type { CellContext } from '@tanstack/vue-table';
import { h } from 'vue';
import PaymentNumbers from './PaymentNumbers.vue';

export const GetPaymentNumbersRenderer = () => {
  return (info: CellContext<any, any>) =>
    h(PaymentNumbers, {
      key: `${info.row.original.id}-${info.row.original.payment_numbers}`,
      info,
    });
};
